// Every Chromium browser installs the same Web Store extension, so navigator.userAgentData.brands is the
// only client-side signal that tells them apart. Brave usually withholds its brand for fingerprint
// resistance, so it reads as Google Chrome — a browser_brand of 'Brave' is best-effort, not exact.
export const CHROMIUM_BROWSER_NAMES = ['Google Chrome', 'Microsoft Edge', 'Opera', 'Brave', 'Vivaldi'];

// The matched browser_brand string (e.g. 'Microsoft Edge'), or null when it can't be determined.
export function chromiumBrowserBrand() {
  const brands = navigator.userAgentData?.brands;
  if (!brands) return null;
  const match = brands.find(({ brand }) => CHROMIUM_BROWSER_NAMES.some((name) => brand.includes(name)));
  return match ? match.brand : null;
}
